









































































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import ShiftDto from '@/models/Shifts/ShiftDto';
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BreakDto from '@/models/Shared/BreakDto';
import DateTimeUtils from '@/lib/dateTimeUtils';
import BookingDateViewModel from '@/models/BookingDates/BookingDateViewModel';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';

@Component({
    name: 'BookingDetailsShiftCreate'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    public bookingRole: BookingRoleDto;
    public dialog = false;
    public entity = new ShiftViewModel();
    public selectedDate: BookingDateViewModel = null;

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            await BookingDetailsModule.getNewBookingOptions();
            const vm: ShiftViewModel = new ShiftViewModel();
            vm.bookingRoleId = this.bookingRole.id;
            vm.startAtTime = "08:00";
            vm.endAtTime = "14:00"
            vm.quantity = 1;
            vm.break = 20;
            vm.isPaidBreak = false;
            this.entity = vm;
        }
    }

    get dates() {
        //Fetch the existing shifts for this role
        const existingShifts = this.bookingRole.shifts;
        
        const allDates = BookingDetailsModule.currentBooking.dates.map(function(bookingDate) {
            const vm: BookingDateViewModel = new BookingDateViewModel();
            vm.bookingDate = bookingDate;
            vm.dateAsString = DateTimeUtils.toDDMMYY(bookingDate.date);
            return vm;
        });
        return allDates;
        // const availableDates = [];
        // //Loop through and remove and dates we already have shifts for
        // for (let i = 0; i < allDates.length; i++) {
        //     const date = allDates[i];
        //     if (!existingShifts.find((findShift: ShiftDto) => date.dateAsString === DateTimeUtils.toDDMMYY(findShift.startAt))) {
        //         availableDates.push(date);
        //     }
        // }
        // return availableDates;

    }

    get breaks() {
        return BookingDetailsModule.newBookingOptions.breaks;
    }

    get loading() {
        return BookingDetailsModule.loadingDialog;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        this.entity.startAtDate = DateTimeUtils.toYYMMDD(this.selectedDate.bookingDate.date);
        await BookingDetailsModule.createShift(this.entity);
        this.dialog = false;
    }
}
